import { axiosPrivate } from "api/axiosCore";

const basic_url = "api/profit-centers";

const request = async (token, method, url, data) => {
  try {
    return await axiosPrivate.request({ method, url, data, headers: { Authorization: `Bearer ${token}` } });
  } catch (error) {
    return error.response || { status: "No Server Response" };
  }
};

export const serviceGetProfitCenters = (token, page = 1, take = 10, query = "") => {
  const search = query ? `&q=${query},${query}&f=profitCenter.name,profitCenter.code&c=OR` : "";
  return request(token, "get", `${basic_url}?page=${page}&take=${take}&order=DESC${search}`);
};

export const servicePostProfitCenter = (token, data) => request(token, "post", basic_url, data);

export const servicePutProfitCenter = (token, id, data) => request(token, "put", `${basic_url}/${id}`, data);
